import ModalShell from './ModalShell'

interface ConfirmDeleteModalProps {
  title: string
  itemName: string
  onConfirm: () => void
  onCancel: () => void
  isPending?: boolean
  error?: Error | null
}

const ConfirmDeleteModal = ({
  title,
  itemName,
  onConfirm,
  onCancel,
  isPending = false,
  error,
}: ConfirmDeleteModalProps) => (
  // Suppress Escape/backdrop dismissal while the request is in flight so a
  // pending DELETE cannot be orphaned by an accidental close.
  <ModalShell title={title} onClose={isPending ? () => {} : onCancel}>
    <div className='px-6 py-5'>
      <p className='text-text-tertiary mt-2 text-sm'>
        Are you sure you want to delete{' '}
        <span className='font-mono text-red-400'>{itemName}</span>?
      </p>
      <p className='text-text-dimmed mt-1 text-sm'>
        This action cannot be undone.
      </p>
      {error && (
        <p className='mt-3 text-sm text-red-400'>
          Failed to delete: {error.message}
        </p>
      )}
    </div>
    <div className='border-border-main flex items-center justify-end gap-3 border-t px-6 py-4'>
      <button
        type='button'
        onClick={onCancel}
        disabled={isPending}
        className='border-border-main text-text-secondary hover:bg-neutral-dimmed rounded-lg border px-4 py-2 text-sm disabled:cursor-not-allowed disabled:opacity-40'
      >
        Cancel
      </button>
      <button
        type='button'
        onClick={onConfirm}
        disabled={isPending}
        className='rounded-lg bg-red-600 px-5 py-2 text-sm font-semibold text-white hover:bg-red-500 disabled:cursor-not-allowed disabled:opacity-40'
      >
        {isPending ? 'Deleting…' : 'Delete'}
      </button>
    </div>
  </ModalShell>
)

export default ConfirmDeleteModal
